import React from 'react';
import strings from 'strings';

import { BannerMobile } from '../Banner';
import * as styles from './AvgPriceBanner.scss';

const AvgPriceBannerMobile = (props) => {
  const {
    avgPriceUrl,
    closeBanner,
    imageUrl,
  } = props;

  return (
    <BannerMobile
      url={avgPriceUrl}
      closeBanner={closeBanner}
      primaryText={strings.avgPriceBannerPrimary}
      buttonText={strings.avgPriceBannerBtn}
      imageUrl={imageUrl}
      imageAlt="avg-price-image"
      className={styles.avgPriceBanner}
    />
  );
};

export default AvgPriceBannerMobile;
